<app-header-dashboard></app-header-dashboard>
<main class="main">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="dashbox">
          <div class="dashbox_title_flex">
            <h2 class="dashbox_title">Transfer</h2>
            <h2 class="dashbox_title">
              Main Balance:
              <span>{{ truncateDecimals(assetData?.spotBal ?? 0, 2) }}</span>
              {{ assetData?.coin }}
            </h2>
          </div>
          <div class="dashbox_title_flex">
            <h2 class="dashbox_title"></h2>
            <h2 class="dashbox_title">
              Grid Balance:
              <span>{{ truncateDecimals(assetData?.gridBal ?? 0, 2) }}</span>
              {{ assetData?.coin }}
            </h2>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 mb-5">
              <form class="auth_form" [formGroup]="form">
                <div class="sign_group sign_group_input">
                  <label>From Wallet</label>
                  <select class="sign_input" name="from" formControlName="from" (change)="inputChange($event)">
                    <option value="">Choose a Wallet</option>
                    <option value="main">Main Wallet</option>
                    <option value="grid">Grid Wallet</option>
                  </select>
                  <span class="required" *ngIf="serverErrors['from']">
                    {{ serverErrors['from'] }}
                  </span>
                </div>

                <div class="sign_group sign_group_input">
                  <label>To Wallet</label>
                  <select class="sign_input" name="to" formControlName="to" (change)="inputChange($event)">
                    <option value="">Choose a Wallet</option>
                    <option value="grid">Grid Wallet</option>
                    <option value="main">Main Wallet</option>
                  </select>
                  <span class="required" *ngIf="serverErrors['to']">
                    {{ serverErrors['to'] }}
                  </span>
                </div>

                <div class="sign_group sign_group_input">
                  <label>Enter Amount</label>
                  <div class="primary_inp_grp">
                    <input type="number" class="sign_input" placeholder="0.00" name="amount" formControlName="amount"
                      [appDecimalLimit]="2" />
                  </div>
                  <span class="required" *ngIf="serverErrors['amount']">
                    {{ serverErrors['amount'] }}
                  </span>
                </div>

                <!-- <button class="trade_sell_btn" type="button"
                  *ngIf="user && user.aadharNumber && user.aadharNumber != 'verified'"
                  (click)="navigate('identification')">
                  KYC Not Verified
                </button> -->

                <!-- <button *ngIf="user?.aadharNumber === 'verified'" class="sign_btn" [disabled]="loading" type="button"
                  (click)="submitForm()">
                  <div *ngIf="loading; else submitButton">
                    <div class="spinner-border spinner-border-sm" role="status"></div>
                    Submitting...
                  </div>
                  <ng-template #submitButton> Submit </ng-template>
                </button> -->

                <button class="sign_btn" [disabled]="loading" type="button" (click)="submitForm()">
                  <div *ngIf="loading; else submitButton">
                    <div class="spinner-border spinner-border-sm" role="status"></div>
                    Submitting...
                  </div>
                  <ng-template #submitButton> Submit </ng-template>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>